<template>
  <as-dialogo ref="dialogoRedefinirSenha" title="Redefinir Senha" max-width="600px">
    <v-container fluid class="pa-0">
      <v-form v-model="formValid" ref="form" lazy-validation>
        <v-row dense>
          <v-col cols="12">
            <v-text-field
              ref="email"
              v-model="emailRedefinir"
              label="E-mail"
              :rules="emailRules"
              :disabled="loading"
              :error-messages="msgErro"
              autofocus
              @keypress.native.enter="enviarCodigo"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row dense>
        <v-col cols="12" style="text-align: right">
          <v-btn
            depressed
            color="primary"
            @click="enviarCodigo"
            :loading="loading"
            :disabled="!formValid || !emailRedefinir || loading"
          >Enviar Código</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </as-dialogo>
</template>

<script>
import config from "@/config";
import ServicesUsers from "@/services/users.js";

export default {
  props: {
    email: { type: String }
  },
  name: "RedefinirSenha",
  data() {
    return {
      emailRedefinir: "",
      emailRules: [v => !!v || "O email é obrigatório"],
      loading: false,
      formValid: true,
      msgErro: ""
    };
  },
  methods: {
    abrir() {
      this.$refs.dialogoRedefinirSenha.abrir();
    },

    fechar() {
      this.$refs.dialogoRedefinirSenha.fechar();
    },

    async enviarCodigo() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        try {
          await ServicesUsers.sendLinkReset(this.emailRedefinir);
          this.$refs.dialogoRedefinirSenha.fechar();
          this.$emit("success", {
            email: this.emailRedefinir,
            reenviarCodigo: false,
            passwordReset: true
          });
        } catch (error) {
          if (typeof error.response !== "undefined") {
            if (error.response.data.status == 2) {
              this.$eventbus.erro(error.response.data.msg);
              this.$refs.dialogoRedefinirSenha.fechar();
              this.$emit("success", {
                email: this.emailRedefinir,
                reenviarCodigo: true,
                passwordReset: true
              });
            } else {
              this.$refs.email.focus();
              this.msgErro = error.response.data.msg;
              setTimeout(() => {
                this.msgErro = "";
              }, 3000);
            }
          }
        }
      } else {
        this.$refs.email.focus();
      }
      this.loading = false;
    }
  },
  watch: {
    email: {
      handler: function(value) {
        this.emailRedefinir = value;
      }
    }
  }
};
</script>

<style></style>
